import React from "react";
import { useTranslation } from "react-i18next";
import { Card, Row } from "react-bootstrap";
import ChartAccesesPerMonth from '../_Base/AccessesPerMonth'
import PropTypes from 'prop-types';

const AccessPerMonth = (props) => {
    const { t } = useTranslation();
    const inputParam_ChartData = props.chartData !== undefined && props.chartData !== null ? props.chartData : null;

    return (  
        <Card style={{height:"300px"}} className="rounded-3">
            <Card.Title>
                <h4 style={ {borderBottom: "2px solid #b1b1b1"}}>{t('data-lang-boxname-chart-accesspermonth') }</h4>
            </Card.Title>
            <Card.Body className="col-xs-12">
                <Row style={ {height: "100%"} } className="align-items-center">
                    <ChartAccesesPerMonth chartData={ inputParam_ChartData } />
                </Row>
            </Card.Body>
        </Card>
    );
};
AccessPerMonth.propTypes = {
    chartData: PropTypes.object.isRequired,
};
export default AccessPerMonth;